import { render, staticRenderFns } from "./scrContact.vue?vue&type=template&id=f21c96d4&scoped=true"
import script from "./scrContact.vue?vue&type=script&lang=js"
export * from "./scrContact.vue?vue&type=script&lang=js"
import style0 from "./scrContact.vue?vue&type=style&index=0&id=f21c96d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21c96d4",
  null
  
)

export default component.exports